import React from "react";
import PropTypes from "prop-types";

export default function PostIdentColoredHeading({methodName, testId}) {
    return <h1 className="row d-flex flex-row">
            <div className="col-auto fs-5 postIdent-logo pr-0">
                <span className="post p-0" id="post">POST</span>
                <span className="ident p-0" id="ident">IDENT</span>
            </div>
        <div className="col-auto title-description d-flex align-items-center p-0"
             data-test-id={testId + '-head'}>{methodName}</div>
    </h1>
}

PostIdentColoredHeading.propTypes = {
    methodName: PropTypes.string,
    testId: PropTypes.string
};